<template>
    <div class="contents group">
        <div class="builder-type-preview">
            <Button :href="modelValue.href" :a="true" target="_blank">{{ modelValue.label }}</Button>
        </div>
        <MountedTeleport v-if="openedIndex === levelIndex" to="#aside">
            <builder-sidebar-segment class="hidden">
                <builder-sidebar-headline>
                    {{ lang('fields::fields.segments.attributes') }}
                </builder-sidebar-headline>
                <builder-sidebar-content>
                    <div v-for="attribute in attributes" :key="attribute.slug">
                        <Field
                            v-model="modelValue[attribute.slug]"
                            :field="attribute"
                            :dusk="`form-content-${levelIndex}-${attribute.slug}`"
                            size="xs"
                            label-position="top"
                        />
                    </div>
                </builder-sidebar-content>
            </builder-sidebar-segment>
        </MountedTeleport>
    </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import BuilderSidebarHeadline from '@src/Content/Pages/Builder/Partials/SidebarHeadline.vue';
import BuilderSidebarSegment from '@src/Content/Pages/Builder/Partials/SidebarSegment.vue';
import BuilderSidebarContent from '@src/Content/Pages/Builder/Partials/SidebarContent.vue';

const modelValue = defineModel({
    type: [Object, undefined],
});

interface Props {
    attributes?: any[];
    levelIndex?: number;
    openedIndex?: number | null;
}

const props = withDefaults(defineProps<Props>(), {
    attributes: () => [],
    levelIndex: 0,
    openedIndex: null,
});

const { attributes, levelIndex, openedIndex } = toRefs(props);
</script>
